import pxToRem from "../../functions/pxToRem";

export default function dialogTitle({ typography, colors, borders }) {
  const { size, fontWeightBold } = typography;
  const { text, grey } = colors;
  const { borderWidth } = borders;

  const dialogTitle = {
    styleOverrides: {
      root: {
        padding: `${pxToRem(20)} ${pxToRem(24)}`,
        fontSize: size.lg,
        fontWeight: fontWeightBold,
        color: text.primary,
        borderBottom: `${borderWidth[1]} solid ${grey[200]}`,
        backgroundColor: grey[100],
        letterSpacing: "-0.01em",
      },
    },
  };

  return dialogTitle;
}
